import { library } from "@fortawesome/fontawesome-svg-core";

import { faAngular, faBootstrap, faCss3, faHtml5, faJsSquare, faReact, faSass, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faBars, faCircle, faDiagramProject, faFaceSmileWink, faGreaterThan, faLink, faPlay, faSchool, faUpDownLeftRight, faUserGraduate, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { faClock, faHeart } from "@fortawesome/free-regular-svg-icons";
import { faIndustry, faStar, faLocationDot, faStarHalf, } from "@fortawesome/free-solid-svg-icons";
import { faPersonDigging } from "@fortawesome/free-solid-svg-icons";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import { faBook } from "@fortawesome/free-solid-svg-icons";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { faHand } from "@fortawesome/free-solid-svg-icons";

library.add(
    faFacebook,
    faGithub,
    faLinkedin,
    faTwitter,
    faLink,
    faHome,
    faHeart,
    faIndustry, 
    faStar, 
    faPersonDigging, 
    faLocationDot, 
    faStarHalf, 
    faCalendarDays,
    faBook,
    faGraduationCap,
    faDiagramProject,
    faFaceSmileWink,
    faHand,
    faReact,
    faAngular,
    faCss3,
    faHtml5,
    faSass,
    faBootstrap,
    faJsSquare,
    faUpDownLeftRight,
    faSchool,
    faUserGraduate,
    faBars,

    //Decorated icons
    faCircle,
    faClock,
    faPlay, faGreaterThan, faStar, faXmark
)